import React, { useEffect, useState } from "react";
import { Container, Table, Button, Modal, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { Image } from "react-bootstrap-icons";
import api from "./api";

function ManageBlogs() {
  const [blogs, setBlogs] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);

  // 🔹 Fetch Blogs
  const fetchBlogs = async () => {
    const res = await api.get("/UiplusBlogs");
    setBlogs(res.data);
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  // 🔹 Delete Blog
  const deleteBlog = async (id) => {
    const res = await api.delete(`/UiplusBlogs/${id}`);
    if (res.status === 200 || res.status === 300) {
      toast.success("✅ Blog Delete successfully");
    } else {
      toast.error("❌ Failed to delete blog");
    }
    fetchBlogs();
  };

  // 🔹 Open Modal
  const openUploadModal = (blog) => {
    setSelectedBlog(blog);
    setShowModal(true);
    setPreview(null);
    setFile(null);
  };

  // 🔹 Handle File Change + Preview
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    setFile(selectedFile);

    const previewUrl = URL.createObjectURL(selectedFile);
    setPreview(previewUrl);
  };

  // 🔹 Upload Image + Update Blog
  const handleUpload = async () => {
    if (!file || !selectedBlog) {
      toast.warning("Please select image");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      // 1. Upload image
      const uploadRes = await api.post("/UiplusBlogs/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const imageUrl = uploadRes.data.imageUrl;

      // 2. Update blog
      await api.put(`/UiplusBlogs/${selectedBlog.blogId}`, {
        ...selectedBlog,
        imageUrl: imageUrl,
      });

      toast.success("✅ Image uploaded successfully");

      setShowModal(false);
      setFile(null);
      setPreview(null);

      fetchBlogs();
    } catch (error) {
      console.error(error);
      toast.error("❌ Upload failed");
    }
  };

  // 🔹 Cleanup preview memory
  useEffect(() => {
    return () => {
      if (preview) URL.revokeObjectURL(preview);
    };
  }, [preview]);

  return (
    <Container className="py-5">
      <h3>Manage Blogs</h3>

      <Table bordered>
        <thead>
          <tr>
            <th>Title</th>
            <th>Slug</th>
            <th>Image</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {blogs.map((b) => (
            <tr key={b.blogId}>
              <td>{b.title}</td>
              <td>{b.slug}</td>

              {/* 🔹 Image Column */}
              <td>
                {b.imageUrl ? (
                  <img
                    src={b.imageUrl}
                    alt=""
                    width="50"
                    style={{ borderRadius: "5px" }}
                  />
                ) : (
                  <Button
                    variant="light"
                    onClick={() => openUploadModal(b)}
                  >
                    <Image size={20} />
                  </Button>
                )}
              </td>

              {/* 🔹 Actions */}
              <td>
                <Button
                  variant="warning"
                  className="me-2"
                  onClick={() => openUploadModal(b)}
                >
                  Upload Image
                </Button>

                <Button
                  variant="danger"
                  onClick={() => deleteBlog(b.blogId)}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* 🔹 Upload Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Upload Blog Image</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group>
            <Form.Label>Select Image</Form.Label>
            <Form.Control type="file" onChange={handleFileChange} />
          </Form.Group>

          {/* 🔹 Preview */}
          {preview && (
            <div className="mt-3 text-center">
              <p className="mb-2">Preview:</p>
              <img
                src={preview}
                alt="Preview"
                style={{
                  width: "100%",
                  maxHeight: "200px",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            </div>
          )}

          {/* 🔹 Existing Image */}
          {!preview && selectedBlog?.imageUrl && (
            <div className="mt-3 text-center">
              <p className="mb-2">Current Image:</p>
              <img
                src={selectedBlog.imageUrl}
                alt=""
                style={{
                  width: "100%",
                  maxHeight: "200px",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>

          <Button variant="success" onClick={handleUpload}>
            Upload
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default ManageBlogs;